"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RequestShoppingContextEvent = exports.Name = void 0;
const Name = exports.Name = 'request-shopping-context';
const RequestShoppingContextEvent = exports.RequestShoppingContextEvent = Name;
